<template>
    <div id="contenedor-editar-documento-proyecto">
      <v-form v-model="formularioValido" ref="formEditarProyectoDocumento">
        <v-card>
          <v-card-title class="secondary--text">
            Editar documento
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrar">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <CustomTextField
                v-model="documento.descripcion"
                cols="12"
                label="Descripción"
                :rules="[mixReglas.requerido]"
              >
              </CustomTextField>
              <CustomDatePicker
                v-model="documento.fecha"
                label="Fecha">
              </CustomDatePicker>
            </v-row>
          </v-card-text>
          <v-divider class="bkground" />
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              class="mr-3"
              tipo="formCancelar"
              label="Cancelar"
              @click="cerrar">
            </custom-button>
            <custom-button
              tipo="formAceptar"
              label="Actualizar"
              :disabled="!formularioValido || enviandoFormulario"
              :loading="enviandoFormulario"
              @click="mixActualizarProyectoDocumento">
            </custom-button>
          </v-card-actions>
        </v-card>
      </v-form>
    </div>
  </template>

<script>
import mixProyectosDocumentos from './mixProyectosDocumentos';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'AgregarDocumentoProyecto',
  mixins: [mixProyectosDocumentos],
  props: {
    proyectoDocumentoEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomDatePicker,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      documento: {
        fecha: this.proyectoDocumentoEditar.fecha,
        descripcion: this.proyectoDocumentoEditar.descripcion,
      },
    };
  },
  methods: {
    cerrar() {
      this.$refs.formEditarProyectoDocumento.reset();
      this.$emit('cerrar');
    },
    seleccionarArchivo() {
      document.getElementById('anexo').click();
    },
  },
};
</script>

  <style lang="scss"></style>
